import { WcsAkamaiCookies } from '../libs/wcs/types/akamai-cookies'
import { WcsLocales } from '../libs/wcs/types/locales'
import { WcsStoreId } from '../libs/wcs/types/store-id'

interface CountryLabels {
  titleLabel: string
  currencyLabel?: string
  paymentsLabel?: string
  benefitsLabel?: string
  shippingLabel?: string
  submitLabel: string
  typeLabel: string
  roeErrorMessage?: string
}
interface WcsCountry {
  id?: string
  lang: WcsLocales
  langId?: string
  label: string
  akamaiCC?: WcsAkamaiCookies
  url: string
  iconFlag: string
  synonymous: string[]
  labels?: CountryLabels
  currency?: string
  hidden?: boolean
  currencyROEValue?: string
}

export const COUNTRY_LIST: WcsCountry[] = [
  {
    id: WcsStoreId.LATAM,
    lang: WcsLocales.ES_AR,
    langId: '-102',
    label: 'Argentina',
    akamaiCC: WcsAkamaiCookies.ARGENTINA,
    url: '/latam',
    iconFlag: 'ar-flag',
    synonymous: ['AR', 'Argentina'],
    labels: {
      titleLabel: 'Escribe tu país',
      currencyLabel: 'Moneda',
      paymentsLabel: 'Métodos de pago disponibles',
      benefitsLabel: 'Beneficios',
      shippingLabel: 'Estás enviando a',
      submitLabel: 'Seleccionar',
      typeLabel: 'Selecciona el país',
    },
  },
  {
    id: WcsStoreId.ASEAN,
    lang: WcsLocales.EN_TH,
    langId: '-100',
    label: 'Asean',
    akamaiCC: WcsAkamaiCookies.ASEAN_CC,
    url: '/asean',
    iconFlag: 'xx-flag',
    synonymous: ['ASEAN', 'Asean'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.AUSTRALIA,
    langId: '-47',
    label: 'Australia',
    lang: WcsLocales.EN_AU,
    url: '/australia',
    currency: '$ AUD',
    iconFlag: 'au-flag',
    synonymous: ['AU', 'Australia'],
    labels: {
      titleLabel: 'Select or type your store',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.BELGIUM,
    langId: '-40',
    label: 'Belgique (FR)',
    lang: WcsLocales.FR_BE,
    url: '/belgium/fr',
    currency: '€ EUR',
    iconFlag: 'be-flag',
    synonymous: ['BE', 'België', 'Belgie', 'Belgien', 'Belgique'],
    labels: {
      titleLabel: 'Sélectionnez ou entrez votre magasin',
      currencyLabel: 'Devise',
      paymentsLabel: 'Modes de paiement disponibles',
      benefitsLabel: 'Avantages',
      shippingLabel: 'Vous livrez à',
      submitLabel: 'Sélectionner',
      typeLabel: 'Choisir un autre magasin',
    },
  },
  {
    id: WcsStoreId.BELGIUM,
    langId: '-41',
    label: 'België (NL)',
    lang: WcsLocales.NL_BE,
    url: '/belgium/nl',
    currency: '€ EUR',
    iconFlag: 'be-flag',
    synonymous: ['BE', 'België', 'Belgie', 'Belgien', 'Belgique'],
    labels: {
      titleLabel: 'Type jouw land in',
      currencyLabel: 'Valuta',
      paymentsLabel: 'Beschikbare betaalwijzen',
      benefitsLabel: 'Voordelen',
      shippingLabel: 'Je verzendt naar',
      submitLabel: 'Selecteren',
      typeLabel: 'Kies een andere winkel',
    },
  },
  {
    id: WcsStoreId.BRAZIL,
    langId: '-53',
    label: 'Brasil',
    lang: WcsLocales.PT_BR,
    url: '/brazil',
    currency: 'R$ BRL',
    iconFlag: 'br-flag',
    synonymous: ['BR', 'Brasil'],
    labels: {
      titleLabel: 'Selecione ou digite sua loja',
      currencyLabel: 'Moeda',
      paymentsLabel: 'Métodos de pagamento disponíveis',
      benefitsLabel: 'Benefícios',
      shippingLabel: 'Você está enviando para',
      submitLabel: 'Selecionar',
      typeLabel: 'Escolha uma loja diferente',
    },
  },
  {
    id: WcsStoreId.CANADA,
    langId: '-24',
    label: 'Canada (EN)',
    lang: WcsLocales.EN_CA,
    url: '/canada/en',
    iconFlag: 'ca-flag',
    currency: '$ CAN',
    synonymous: ['CA', 'Canada'],
    labels: {
      titleLabel: 'Select or type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.CANADA,
    langId: '-25',
    label: 'Canada (FR)',
    lang: WcsLocales.FR_CA,
    url: '/canada/fr',
    iconFlag: 'ca-flag',
    currency: '$ CAN',
    synonymous: ['CA'],
    labels: {
      titleLabel: 'Sélectionner ou saisir votre magasin',
      currencyLabel: 'Devise',
      paymentsLabel: 'Modes de paiement disponibles',
      benefitsLabel: 'Avantages',
      shippingLabel: 'Vous livrez à',
      submitLabel: 'Sélectionner',
      typeLabel: 'Choisir un autre magasin',
    },
  },
  {
    id: WcsStoreId.LATAM,
    lang: WcsLocales.ES_AR,
    langId: '-102',
    label: 'Chile',
    akamaiCC: WcsAkamaiCookies.CHILE,
    url: '/latam',
    iconFlag: 'cl-flag',
    synonymous: ['CL', 'Chile'],
    hidden: true,
  },
  {
    id: WcsStoreId.LATAM,
    lang: WcsLocales.ES_AR,
    langId: '-102',
    label: 'Colombia',
    akamaiCC: WcsAkamaiCookies.COLOMBIA,
    url: '/latam',
    iconFlag: 'co-flag',
    synonymous: ['CO', 'Colombia'],
    hidden: true,
  },
  {
    id: WcsStoreId.LATAM,
    lang: WcsLocales.ES_AR,
    langId: '-102',
    label: 'Costa Rica',
    akamaiCC: WcsAkamaiCookies.COSTA_RICA,
    url: '/latam',
    iconFlag: 'co-flag',
    synonymous: ['CR', 'Costa Rica'],
    hidden: true,
  },
  {
    id: WcsStoreId.REST_OF_EUROPE,
    langId: '-46',
    akamaiCC: WcsAkamaiCookies.CYPRUS,
    label: 'Cyprus',
    lang: WcsLocales.CY_EN,
    url: '/eu',
    iconFlag: 'cy-flag',
    currency: '€ EUR',
    currencyROEValue: 'ECM',
    synonymous: ['CY', 'Cyprus', 'Cipro'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      roeErrorMessage: 'Please, select a country to proceed',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.DENMARK,
    langId: '-36',
    label: 'Denmark',
    lang: WcsLocales.EN_DK,
    url: '/denmark',
    iconFlag: 'dk-flag',
    currency: '€ EUR',
    synonymous: ['DK', 'Danmark'],
    labels: {
      titleLabel: 'Select or type your store',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.GERMANY,
    langId: '-3',
    label: 'Deutschland',
    lang: WcsLocales.DE_DE,
    url: '/germany',
    iconFlag: 'de-flag',
    currency: '€ EUR',
    synonymous: ['DE', 'Bundesrepublik', 'Deutschland', 'Germany'],
    labels: {
      titleLabel: 'Ihr Geschäft auswählen oder eingeben',
      currencyLabel: 'Währung',
      paymentsLabel: 'Verfügbare Zahlungsmethoden',
      benefitsLabel: 'Vorteile',
      shippingLabel: 'Versand nach',
      submitLabel: 'Wählen',
      typeLabel: 'Anderes Geschäft wählen',
    },
  },
  {
    id: WcsStoreId.LATAM,
    lang: WcsLocales.ES_AR,
    langId: '-102',
    label: 'Ecuador',
    akamaiCC: WcsAkamaiCookies.ECUADOR,
    url: '/latam',
    iconFlag: 'ec-flag',
    synonymous: ['EC', 'Ecuador'],
    hidden: true,
  },
  {
    id: WcsStoreId.SPAIN,
    langId: '-5',
    label: 'España',
    lang: WcsLocales.ES_ES,
    url: '/spain',
    iconFlag: 'es-flag',
    currency: '€ EUR',
    synonymous: ['ES', 'España'],
    labels: {
      titleLabel: 'Selecciona o teclea tu tienda',
      currencyLabel: 'Moneda',
      paymentsLabel: 'Métodos de pago disponibles',
      benefitsLabel: 'Beneficios',
      shippingLabel: 'Estás enviando a',
      submitLabel: 'Seleccionar',
      typeLabel: 'Selecciona una tienda diferente',
    },
  },
  {
    id: WcsStoreId.REST_OF_EUROPE,
    akamaiCC: WcsAkamaiCookies.ESTONIA,
    langId: '-46',
    label: 'Estonia',
    lang: WcsLocales.ET_EE,
    url: '/eu',
    iconFlag: 'ee-flag',
    currency: '€ EUR',
    currencyROEValue: 'EEU',
    synonymous: ['EE', 'Eesti', 'Estonia'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      roeErrorMessage: 'Please, select a country to proceed',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.FINLAND,
    langId: '-46',
    akamaiCC: WcsAkamaiCookies.FINLAND,
    label: 'Finland',
    lang: WcsLocales.FI_FI,
    url: '/eu',
    iconFlag: 'fi-flag',
    currency: '€ EUR',
    currencyROEValue: 'EFI',
    synonymous: ['Finland', 'FI', 'Suomi'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.FRANCE,
    langId: '-2',
    label: 'France',
    lang: WcsLocales.FR_FR,
    url: '/france',
    currency: '€ EUR',
    iconFlag: 'fr-flag',
    synonymous: ['FR', 'France', 'République française'],
    labels: {
      titleLabel: 'Sélectionnez ou entrez votre magasin',
      currencyLabel: 'Devise',
      paymentsLabel: 'Modes de paiement disponibles',
      benefitsLabel: 'Avantages',
      roeErrorMessage: 'Please, select a country to proceed',
      shippingLabel: 'Vous livrez à',
      submitLabel: 'Choisir',
      typeLabel: 'Choisir un autre magasin',
    },
  },
  {
    id: WcsStoreId.REST_OF_EUROPE,
    akamaiCC: WcsAkamaiCookies.GREECE,
    langId: '-46',
    label: 'Greece',
    lang: WcsLocales.EL_GR,
    url: '/eu',
    currency: '€ EUR',
    currencyROEValue: 'EGR',
    iconFlag: 'gr-flag',
    synonymous: ['GR', 'Greece'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      roeErrorMessage: 'Please, select a country to proceed',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.HONG_KONG,
    langId: '-48',
    label: 'Hong Kong SAR',
    lang: WcsLocales.EN_HK,
    url: '/hongkong/en',
    iconFlag: 'xx-flag',
    currency: 'HK$',
    synonymous: ['HK', 'Chinese', 'Hongkong'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    label: 'India',
    lang: WcsLocales.HI_IN,
    url: '/india',
    iconFlag: 'in-flag',
    currency: '₹ INR',
    synonymous: ['IN', 'India'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.ASEAN,
    langId: '-100',
    label: 'Indonesia',
    akamaiCC: WcsAkamaiCookies.INDONESIA,
    lang: WcsLocales.EN_TH,
    url: '/asean',
    iconFlag: 'id-flag',
    synonymous: ['Indonesia', 'ID'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.IRELAND,
    langId: '-45',
    label: 'Ireland',
    lang: WcsLocales.EN_IE,
    url: '/ireland',
    iconFlag: 'ie-flag',
    currency: '€ EUR',
    synonymous: ['IE', 'Ireland', 'Éire'],
    labels: {
      titleLabel: 'Select or type your store',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    lang: WcsLocales.EN_IL,
    label: 'Iceland',
    akamaiCC: WcsAkamaiCookies.ISLAND,
    url: '/row',
    iconFlag: 'is-flag',
    synonymous: ['Iceland', 'IS', 'ISL'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    lang: WcsLocales.EN_IL,
    label: 'Israel',
    akamaiCC: WcsAkamaiCookies.ISRAEL,
    url: '/row',
    iconFlag: 'il-flag',
    synonymous: ['Israel', 'IL'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    lang: WcsLocales.EN_IL,
    label: 'International',
    akamaiCC: WcsAkamaiCookies.INT_CC,
    url: '/row',
    iconFlag: 'xx-flag',
    synonymous: ['International'],
    labels: {
      titleLabel: 'Type your country',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    lang: WcsLocales.EN_IL,
    label: 'Myanmar',
    akamaiCC: WcsAkamaiCookies.MYANMAR,
    url: '/row',
    iconFlag: 'xx-flag',
    synonymous: ['Myanmar', 'Burma'],
    labels: {
      titleLabel: 'Type your country',
      submitLabel: 'Type your country',
      typeLabel: 'Choose different store',
    },
    hidden: true,
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    lang: WcsLocales.EN_IL,
    label: 'Sri Lanka',
    akamaiCC: WcsAkamaiCookies.SRI_LANKA,
    url: '/row',
    iconFlag: 'xx-flag',
    synonymous: ['Sri Lanka'],
    labels: {
      titleLabel: 'Type your country',
      submitLabel: 'Type your country',
      typeLabel: 'Choose different store',
    },
    hidden: true,
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    lang: WcsLocales.EN_IL,
    label: 'Bangladesh',
    akamaiCC: WcsAkamaiCookies.BANGLADESH,
    url: '/row',
    iconFlag: 'xx-flag',
    synonymous: ['Bangladesh'],
    labels: {
      titleLabel: 'Type your country',
      submitLabel: 'Type your country',
      typeLabel: 'Choose different store',
    },
    hidden: true,
  },
  {
    id: WcsStoreId.ITALY,
    langId: '-4',
    label: 'Italia',
    lang: WcsLocales.IT_IT,
    iconFlag: 'it-flag',
    url: '/italy',
    currency: '€ EUR',
    synonymous: ['IT', 'Italia'],
    labels: {
      titleLabel: 'Seleziona o digita il tuo negozio',
      currencyLabel: 'Valuta',
      paymentsLabel: 'Metodi di pagamento disponibili',
      benefitsLabel: 'Vantaggi',
      shippingLabel: 'Paese di destinazione',
      submitLabel: 'Scegli',
      typeLabel: 'Scegli un altro negozio',
    },
  },
  {
    id: WcsStoreId.KOREA,
    langId: '-9',
    label: 'Korea',
    lang: WcsLocales.KO_KR,
    url: '/korea',
    iconFlag: 'kr-flag',
    currency: 'WON',
    synonymous: ['Korea', 'KR', 'South Korea'],
    labels: {
      titleLabel: '매장을 선택하거나 입력하세요',
      currencyLabel: '통화',
      paymentsLabel: '이용 가능한 결제 방법',
      benefitsLabel: '혜택',
      shippingLabel: '배송 국가',
      submitLabel: '선택하기',
      typeLabel: '다른 매장을 선택하세요',
    },
  },
  {
    id: WcsStoreId.LATAM,
    lang: WcsLocales.ES_AR,
    langId: '-102',
    label: 'Latin America',
    url: '/latam',
    iconFlag: 'xx-flag',
    akamaiCC: WcsAkamaiCookies.LATAM_CC,
    synonymous: ['LATAM', 'Latin America'],
    labels: {
      titleLabel: 'Escribe tu país',
      currencyLabel: 'Moneda',
      paymentsLabel: 'Métodos de pago disponibles',
      benefitsLabel: 'Beneficios',
      shippingLabel: 'Estás enviando a',
      submitLabel: 'Seleccionar',
      typeLabel: 'Selecciona una tienda diferente',
    },
  },
  {
    id: WcsStoreId.REST_OF_EUROPE,
    akamaiCC: WcsAkamaiCookies.LATVIA,
    langId: '-46',
    label: 'Latvia',
    lang: WcsLocales.LV_LV,
    url: '/eu',
    iconFlag: 'lv-flag',
    currency: '€ EUR',
    currencyROEValue: 'EEU',
    synonymous: ['LV'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      roeErrorMessage: 'Please, select a country to proceed',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_EUROPE,
    akamaiCC: WcsAkamaiCookies.LITHUANIA,
    langId: '-46',
    label: 'Lithuania',
    lang: WcsLocales.LT_LT,
    url: '/eu',
    iconFlag: 'lt-flag',
    currency: '€ EUR',
    currencyROEValue: 'EEU',
    synonymous: ['Lithuania', 'LT'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      roeErrorMessage: 'Please, select a country to proceed',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_EUROPE,
    akamaiCC: WcsAkamaiCookies.LUXEMBOURG,
    langId: '-46',
    label: 'Luxembourg',
    lang: WcsLocales.DE_LU,
    url: '/eu',
    currency: '€ EUR',
    currencyROEValue: 'EUB',
    iconFlag: 'lu-flag',
    synonymous: ['LU', 'Luxembourg'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      roeErrorMessage: 'Please, select a country to proceed',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.MIDDLE_EAST,
    lang: WcsLocales.EN_DZ,
    langId: '-103',
    label: 'Middle East',
    akamaiCC: WcsAkamaiCookies.MEA_CC,
    url: '/mea',
    iconFlag: 'xx-flag',
    synonymous: ['MENA', 'MEA', 'AR', 'Middle East'],
    labels: {
      titleLabel: 'Select or type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.MIDDLE_EAST,
    lang: WcsLocales.EN_DZ,
    langId: '-103',
    label: 'Algeria',
    akamaiCC: WcsAkamaiCookies.ALGERIA,
    url: '/mea',
    iconFlag: 'xx-flag',
    synonymous: ['Algeria'],
    labels: {
      titleLabel: 'Select or type your country',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
    hidden: true,
  },
  {
    id: WcsStoreId.MIDDLE_EAST,
    lang: WcsLocales.EN_DZ,
    langId: '-103',
    label: 'Arab Emirates',
    akamaiCC: WcsAkamaiCookies.UNITED_ARAB_EMIRATES,
    url: '/mea',
    iconFlag: 'xx-flag',
    synonymous: ['Arab Emirates'],
    labels: {
      titleLabel: 'Select or type your country',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
    hidden: true,
  },
  {
    id: WcsStoreId.MIDDLE_EAST,
    lang: WcsLocales.EN_DZ,
    langId: '-103',
    label: 'Bahrain',
    akamaiCC: WcsAkamaiCookies.BAHRAIN,
    url: '/mea',
    iconFlag: 'xx-flag',
    synonymous: ['Bahrain'],
    labels: {
      titleLabel: 'Select or type your country',
      submitLabel: 'Select or type your country',
      typeLabel: 'Choose different store',
    },
    hidden: true,
  },
  {
    id: WcsStoreId.MIDDLE_EAST,
    lang: WcsLocales.EN_DZ,
    langId: '-103',
    label: 'Egypt',
    akamaiCC: WcsAkamaiCookies.EGYPT,
    url: '/mea',
    iconFlag: 'xx-flag',
    synonymous: ['Egypt'],
    labels: {
      titleLabel: 'Select or type your country',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
    hidden: true,
  },
  {
    id: WcsStoreId.MIDDLE_EAST,
    lang: WcsLocales.EN_DZ,
    langId: '-103',
    label: 'Ivory Coast',
    akamaiCC: WcsAkamaiCookies.IVORY_COAST,
    url: '/mea',
    iconFlag: 'xx-flag',
    synonymous: ['Ivory Coast'],
    labels: {
      titleLabel: 'Select or type your country',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
    hidden: true,
  },
  {
    id: WcsStoreId.MIDDLE_EAST,
    lang: WcsLocales.EN_DZ,
    langId: '-103',
    label: 'Jordan',
    akamaiCC: WcsAkamaiCookies.JORDAN,
    url: '/mea',
    iconFlag: 'xx-flag',
    synonymous: ['Jordan'],
    labels: {
      titleLabel: 'Select or type your country',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
    hidden: true,
  },
  {
    id: WcsStoreId.MIDDLE_EAST,
    lang: WcsLocales.EN_DZ,
    langId: '-103',
    label: 'Kuwait',
    akamaiCC: WcsAkamaiCookies.KUWAIT,
    url: '/mea',
    iconFlag: 'xx-flag',
    synonymous: ['Kuwait'],
    labels: {
      titleLabel: 'Select or type your country',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
    hidden: true,
  },
  {
    id: WcsStoreId.MIDDLE_EAST,
    lang: WcsLocales.EN_DZ,
    langId: '-103',
    label: 'Lebanon',
    akamaiCC: WcsAkamaiCookies.LEBANON,
    url: '/mea',
    iconFlag: 'xx-flag',
    synonymous: ['Lebanon'],
    labels: {
      titleLabel: 'Select or type your country',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
    hidden: true,
  },
  {
    id: WcsStoreId.MIDDLE_EAST,
    lang: WcsLocales.EN_DZ,
    langId: '-103',
    label: 'Morocco',
    akamaiCC: WcsAkamaiCookies.MOROCCO,
    url: '/mea',
    iconFlag: 'xx-flag',
    synonymous: ['Morocco'],
    labels: {
      titleLabel: 'Select or type your country',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
    hidden: true,
  },
  {
    id: WcsStoreId.MIDDLE_EAST,
    lang: WcsLocales.EN_DZ,
    langId: '-103',
    label: 'Oman',
    akamaiCC: WcsAkamaiCookies.OMAN,
    url: '/mea',
    iconFlag: 'xx-flag',
    synonymous: ['Oman'],
    labels: {
      titleLabel: 'Select or type your country',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
    hidden: true,
  },
  {
    id: WcsStoreId.MIDDLE_EAST,
    lang: WcsLocales.EN_DZ,
    langId: '-103',
    label: 'Qatar',
    akamaiCC: WcsAkamaiCookies.QATAR,
    url: '/mea',
    iconFlag: 'xx-flag',
    synonymous: ['Qatar'],
    labels: {
      titleLabel: 'Select or type your country',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
    hidden: true,
  },
  {
    id: WcsStoreId.MIDDLE_EAST,
    lang: WcsLocales.EN_DZ,
    langId: '-103',
    label: 'Saudi Arabia',
    akamaiCC: WcsAkamaiCookies.SAUDI_ARABIA,
    url: '/mea',
    iconFlag: 'xx-flag',
    synonymous: ['Saudi Arabia'],
    labels: {
      titleLabel: 'Select or type your country',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
    hidden: true,
  },
  {
    id: WcsStoreId.MIDDLE_EAST,
    lang: WcsLocales.EN_DZ,
    langId: '-103',
    label: 'Senegal',
    akamaiCC: WcsAkamaiCookies.SENEGAL,
    url: '/mea',
    iconFlag: 'xx-flag',
    synonymous: ['Senegal'],
    labels: {
      titleLabel: 'Select or type your country',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
    hidden: true,
  },
  {
    id: WcsStoreId.MIDDLE_EAST,
    lang: WcsLocales.EN_DZ,
    langId: '-103',
    label: 'Tunisia',
    akamaiCC: WcsAkamaiCookies.TUNISIA,
    url: '/mea',
    iconFlag: 'xx-flag',
    synonymous: ['Tunisia'],
    labels: {
      titleLabel: 'Select or type your country',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
    hidden: true,
  },
  {
    id: WcsStoreId.ASEAN,
    langId: '-100',
    label: 'Malaysia',
    akamaiCC: WcsAkamaiCookies.MALAYSIA,
    lang: WcsLocales.EN_TH,
    url: '/asean',
    iconFlag: 'my-flag',
    synonymous: ['Malaysia', 'MY'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_EUROPE,
    akamaiCC: 'MT',
    langId: '-46',
    label: 'Malta',
    lang: WcsLocales.EN_MT,
    url: '/eu',
    iconFlag: 'mt-flag',
    currency: '€ EUR',
    currencyROEValue: 'ECM',
    synonymous: ['Malt', 'MT'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      roeErrorMessage: 'Please, select a country to proceed',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    lang: WcsLocales.EN_IL,
    label: 'Montenegro',
    akamaiCC: WcsAkamaiCookies.MONTENEGRO,
    url: '/row',
    iconFlag: 'me-flag',
    synonymous: ['ME', 'Montenegro', 'South East Europe'],
    hidden: true,
  },
  {
    id: WcsStoreId.MEXICO,
    langId: '-50',
    label: 'México',
    lang: WcsLocales.ES_MX,
    url: '/mexico',
    iconFlag: 'mx-flag',
    currency: '$ MXN',
    synonymous: ['México', 'MX', 'Mexicanos'],
    labels: {
      titleLabel: 'Selecciona o ingresa tu tienda',
      currencyLabel: 'Moneda',
      paymentsLabel: 'Métodos de pago disponibles',
      benefitsLabel: 'Beneficios',
      shippingLabel: 'Estás enviando a',
      submitLabel: 'Seleccionar',
      typeLabel: 'Elige una tienda diferente',
    },
  },
  {
    id: WcsStoreId.NETHERLANDS,
    langId: '-44',
    label: 'Netherlands',
    lang: WcsLocales.NL_NL,
    url: '/netherlands',
    iconFlag: 'nl-flag',
    currency: '€ EUR',
    synonymous: ['NL', 'Holland', 'Nederland', 'Netherlands'],
    labels: {
      titleLabel: 'Selecteer je land',
      currencyLabel: 'Valuta',
      paymentsLabel: 'Beschikbare betaalwijzen',
      benefitsLabel: 'Voordelen',
      shippingLabel: 'Je verzendt naar',
      submitLabel: 'Selecteren',
      typeLabel: 'Kies een andere winkel',
    },
  },
  {
    id: WcsStoreId.NORWAY,
    langId: '-38',
    label: 'Norway',
    lang: WcsLocales.EN_NO,
    url: '/norway',
    iconFlag: 'no-flag',
    currency: '€ EUR',
    synonymous: ['NO', 'Norge', 'Noreg', 'Norway'],
    labels: {
      titleLabel: 'Select or type your store',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.LATAM,
    lang: WcsLocales.ES_AR,
    langId: '-102',
    label: 'Peru',
    akamaiCC: WcsAkamaiCookies.PERU,
    url: '/latam',
    iconFlag: 'pe-flag',
    synonymous: ['PE', 'Peru'],
    hidden: true,
  },
  {
    id: WcsStoreId.POLAND,
    langId: '-33',
    label: 'Polska',
    lang: WcsLocales.EN_PL,
    url: '/poland',
    iconFlag: 'pl-flag',
    currency: 'PLN',
    synonymous: ['PL', 'Polska', 'Poland'],
    labels: {
      titleLabel: 'Wybierz lub wpisz swój sklep',
      currencyLabel: 'Waluta',
      paymentsLabel: 'Dostępne metody płatności',
      benefitsLabel: 'Zalety',
      shippingLabel: 'Twój kraj dostawy',
      submitLabel: 'Wybierz',
      typeLabel: 'Wybierz inny sklep',
    },
  },
  {
    id: WcsStoreId.PORTUGAL,
    langId: '-42',
    label: 'Portugal',
    lang: WcsLocales.PT_PT,
    url: '/portugal',
    currency: '€ EUR',
    iconFlag: 'pt-flag',
    synonymous: ['Portugal', 'PT'],
    labels: {
      titleLabel: 'Select or type your store',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    lang: WcsLocales.EN_IL,
    label: 'Romania',
    akamaiCC: WcsAkamaiCookies.ROMANIA,
    url: '/row',
    iconFlag: 'ro-flag',
    synonymous: ['RO', 'Romania'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    lang: WcsLocales.EN_IL,
    label: 'Russia',
    akamaiCC: WcsAkamaiCookies.RUSSIA,
    url: '/row',
    iconFlag: 'ru-flag',
    synonymous: ['RU', 'Russia', 'Russian', 'Federation Rossiya'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    lang: WcsLocales.EN_IL,
    label: 'Rest Of World',
    akamaiCC: WcsAkamaiCookies.ROW_CC,
    url: '/row',
    iconFlag: 'xx-flag',
    synonymous: ['ROW', 'Rest Of World'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    lang: WcsLocales.EN_IL,
    label: 'South East Europe',
    akamaiCC: WcsAkamaiCookies.SEE_CC,
    url: '/row',
    iconFlag: 'xx-flag',
    synonymous: ['SEE', 'South East Europe'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    lang: WcsLocales.EN_IL,
    label: 'Serbia',
    akamaiCC: WcsAkamaiCookies.SERBIA,
    url: '/row',
    iconFlag: 'rs-flag',
    synonymous: ['RS', 'Serbia', 'South East Europe'],
    hidden: true,
  },
  {
    id: WcsStoreId.AUSTRIA,
    langId: '-39',
    label: 'Österreich',
    lang: WcsLocales.DE_AT,
    url: '/austria',
    iconFlag: 'at-flag',
    currency: '€ EUR',
    synonymous: ['AT', 'Österreich', 'Osterreich', 'Oesterreich', 'Austria'],
    labels: {
      titleLabel: 'Land eingeben',
      currencyLabel: 'Währung',
      paymentsLabel: 'Verfügbare Zahlungsmethoden',
      benefitsLabel: 'Vorteile',
      shippingLabel: 'Versand nach',
      submitLabel: 'Wählen',
      typeLabel: 'Land auswählen',
    },
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    label: 'Macedonia',
    langId: '-101',
    lang: WcsLocales.EN_IL,
    akamaiCC: WcsAkamaiCookies.NORTH_MACEDONIA,
    url: '/row',
    iconFlag: 'mk-flag',
    synonymous: ['MK', 'Macedonia', 'South East Europe'],
    hidden: true,
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    label: 'Georgia',
    langId: '-101',
    lang: WcsLocales.EN_IL,
    akamaiCC: WcsAkamaiCookies.GEORGIA,
    url: '/row',
    iconFlag: 'ge-flag',
    synonymous: ['GE', 'Georgia', 'South East Europe'],
    hidden: true,
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    label: 'Bulgaria',
    lang: WcsLocales.EN_IL,
    akamaiCC: WcsAkamaiCookies.BULGARIA,
    url: '/row',
    iconFlag: 'bg-flag',
    synonymous: ['BG', 'Bulgaria', 'South East Europe'],
    hidden: true,
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    lang: WcsLocales.EN_IL,
    label: 'Armenia',
    akamaiCC: WcsAkamaiCookies.ARMENIA,
    url: '/row',
    iconFlag: 'am-flag',
    synonymous: ['AM', 'Armenia', 'South East Europe'],
    hidden: true,
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    label: 'Bosnia And Herzegovina',
    lang: WcsLocales.EN_IL,
    akamaiCC: WcsAkamaiCookies.BOSNIA_AND_HERZEGOVINA,
    url: '/row',
    iconFlag: 'ba-flag',
    synonymous: ['BA', 'Bosnia And Herzegovina', 'South East Europe'],
    hidden: true,
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    label: 'Albania',
    lang: WcsLocales.EN_IL,
    akamaiCC: WcsAkamaiCookies.ALBANIA,
    url: '/row',
    iconFlag: 'al-flag',
    synonymous: ['AL', 'Albania', 'South East Europe'],
    hidden: true,
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    lang: WcsLocales.EN_IL,
    label: 'Ukraine',
    akamaiCC: WcsAkamaiCookies.UKRAINE,
    url: '/row',
    iconFlag: 'ua-flag',
    synonymous: ['UA', 'Ukraine'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    label: 'Croatia',
    lang: WcsLocales.EN_IL,
    akamaiCC: WcsAkamaiCookies.CROATIA,
    url: '/row',
    iconFlag: 'hr-flag',
    synonymous: ['HR', 'Croatia'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    label: 'Hungary',
    lang: WcsLocales.EN_IL,
    akamaiCC: WcsAkamaiCookies.HUNGARY,
    url: '/row',
    iconFlag: 'hu-flag',
    synonymous: ['HU', 'Hungary'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    label: 'Czech Republic',
    langId: '-101',
    lang: WcsLocales.EN_IL,
    akamaiCC: WcsAkamaiCookies.CZECH_REPUBLIC,
    url: '/row',
    iconFlag: 'cz-flag',
    synonymous: ['CZ', 'Czech Republic'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    label: 'South Africa',
    langId: '-101',
    lang: WcsLocales.EN_IL,
    akamaiCC: WcsAkamaiCookies.SOUTH_AFRICA,
    url: '/row',
    iconFlag: 'za-flag',
    synonymous: ['ZA', 'South Africa'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    label: 'Pakistan',
    lang: WcsLocales.EN_IL,
    akamaiCC: WcsAkamaiCookies.PAKISTAN,
    url: '/row',
    iconFlag: 'pk-flag',
    synonymous: ['PK', 'Pakistan'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    label: 'Vietnam',
    lang: WcsLocales.EN_IL,
    akamaiCC: WcsAkamaiCookies.VIETNAM,
    url: '/row',
    iconFlag: 'vn-flag',
    synonymous: ['VN', 'Vietnam'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    label: 'Azerbaijan',
    lang: WcsLocales.EN_IL,
    akamaiCC: WcsAkamaiCookies.AZERBAIJAN,
    url: '/row',
    iconFlag: 'aze-flag',
    synonymous: ['AZE', 'Azerbaijan'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_WORLD,
    langId: '-101',
    lang: WcsLocales.EN_IL,
    label: 'Kosovo',
    akamaiCC: WcsAkamaiCookies.KOSOVO,
    url: '/row',
    iconFlag: 'xx-flag',
    synonymous: ['RKT', 'Kosovo', 'South East Europe'],
    labels: {
      titleLabel: 'Type your country',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.SWITZERLAND,
    langId: '-29',
    label: 'Schweiz (DE)',
    lang: WcsLocales.DE_CH,
    url: '/switzerland/de',
    currency: 'CHF',
    iconFlag: 'ch-flag',
    synonymous: ['DE', 'Bundesrepublik', 'Deutschland', 'Germany', 'Schweiz'],
    labels: {
      titleLabel: 'Ihr Geschäft auswählen oder eingeben',
      currencyLabel: 'Währung',
      paymentsLabel: 'Verfügbare Zahlungsmethoden',
      benefitsLabel: 'Vorteile',
      shippingLabel: 'Versand nach',
      submitLabel: 'Wählen',
      typeLabel: 'Anderes Geschäft wählen',
    },
  },
  {
    id: WcsStoreId.ASEAN,
    langId: '-100',
    label: 'Singapore',
    akamaiCC: WcsAkamaiCookies.SINGAPORE,
    lang: WcsLocales.EN_TH,
    url: '/asean',
    iconFlag: 'sg-flag',
    synonymous: ['SG', 'Singapor'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_EUROPE,
    akamaiCC: WcsAkamaiCookies.SLOVAKIA,
    langId: '-46',
    label: 'Slovakia',
    lang: WcsLocales.EN_SK,
    url: '/eu',
    currency: '€ EUR',
    currencyROEValue: 'ESK',
    iconFlag: 'sk-flag',
    synonymous: ['SK', 'Slovakia'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      roeErrorMessage: 'Please, select a country to proceed',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.REST_OF_EUROPE,
    akamaiCC: WcsAkamaiCookies.SLOVENIA,
    langId: '-46',
    label: 'Slovenia',
    lang: WcsLocales.SL_SI,
    url: '/eu',
    currency: '€ EUR',
    currencyROEValue: 'ESL',
    iconFlag: 'si-flag',
    synonymous: ['Slovenia', 'SI'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      roeErrorMessage: 'Please, select a country to proceed',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.SWITZERLAND,
    langId: '-28',
    label: 'Suisse (FR)',
    lang: WcsLocales.FR_CH,
    iconFlag: 'ch-flag',
    url: '/switzerland/fr',
    currency: 'CHF',
    synonymous: [
      'CH',
      'Swiss',
      'Switzerland Confederation',
      'Schweiz',
      'Suisse',
      'Svizzera',
      'Svizra',
    ],
    labels: {
      titleLabel: 'Sélectionnez ou entrez votre magasin',
      currencyLabel: 'Devise',
      paymentsLabel: 'Modes de paiement disponibles',
      benefitsLabel: 'Avantages',
      shippingLabel: 'Vous livrez à',
      submitLabel: 'Sélectionner',
      typeLabel: 'Choisir un autre magasin',
    },
  },
  {
    id: WcsStoreId.SWITZERLAND,
    langId: '-27',
    label: 'Svizzera (IT)',
    lang: WcsLocales.IT_CH,
    url: '/switzerland/it',
    iconFlag: 'ch-flag',
    currency: 'CHF',
    synonymous: [
      'CH',
      'Swiss',
      'Switzerland Confederation',
      'Schweiz',
      'Suisse',
      'Svizzera',
      'Svizra',
    ],
    labels: {
      titleLabel: 'Digita il paese',
      currencyLabel: 'Valuta',
      paymentsLabel: 'Metodi di pagamento disponibili',
      benefitsLabel: 'Vantaggi',
      shippingLabel: 'Paese di destinazione',
      submitLabel: 'Scegli',
      typeLabel: 'Scegli un altro negozio',
    },
  },
  {
    id: WcsStoreId.SWEDEN,
    langId: '-37',
    label: 'Sweden',
    lang: WcsLocales.EN_SE,
    url: '/sweden',
    iconFlag: 'se-flag',
    currency: '€ EUR',
    synonymous: ['SE', 'Sverige', 'Sweden'],
    labels: {
      titleLabel: 'Välj eller skriv in din butik',
      currencyLabel: 'Valuta',
      paymentsLabel: 'Tillgängliga betalningssätt',
      benefitsLabel: 'Fördelar',
      shippingLabel: 'Du skickar till',
      submitLabel: 'Välj',
      typeLabel: 'Välj en annan butik',
    },
  },
  {
    id: WcsStoreId.SWITZERLAND,
    langId: '-30',
    label: 'Switzerland (EN)',
    lang: WcsLocales.EN_CH,
    url: '/switzerland/en',
    iconFlag: 'ch-flag',
    currency: 'CHF',
    synonymous: [
      'CH',
      'Swiss',
      'Switzerland Confederation',
      'Schweiz',
      'Suisse',
      'Svizzera',
      'Svizra',
    ],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.ASEAN,
    langId: '-100',
    label: 'Taiwan Region',
    akamaiCC: WcsAkamaiCookies.TAIWAN,
    lang: WcsLocales.EN_TH,
    url: '/asean',
    iconFlag: 'xx-flag',
    currency: 'TWN',
    synonymous: ['Chinese', 'Taiwan', 'TW'],
    labels: {
      titleLabel: '填写你的国家',
      currencyLabel: '货币',
      paymentsLabel: '可用的付款方式',
      benefitsLabel: '优势',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: '选择国家',
    },
  },
  {
    id: WcsStoreId.ASEAN,
    langId: '-100',
    label: 'Thailand',
    akamaiCC: WcsAkamaiCookies.THAILAND,
    lang: WcsLocales.EN_TH,
    url: '/asean',
    iconFlag: 'th-flag',
    synonymous: ['TH', 'Thailand'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.TURKEY,
    langId: '-104',
    label: 'Türkiye',
    lang: WcsLocales.EN_TR,
    akamaiCC: WcsAkamaiCookies.TURKEY,
    url: '/turkey',
    iconFlag: 'tr-flag',
    currency: 'TRY',
    synonymous: ['TR', 'Türkiye', 'Turkiye'],
    labels: {
      titleLabel: 'Type your country',
      currencyLabel: 'Para birimi',
      paymentsLabel: 'Mevcut ödeme yöntemleri',
      benefitsLabel: 'Faydalar',
      shippingLabel: 'Gönderilecek ülke',
      submitLabel: 'Select',
      typeLabel: 'Farklı bir mağaza seçin',
    },
  },
  {
    id: WcsStoreId.UNITED_KINGDOM,
    langId: '-43',
    label: 'UK',
    lang: WcsLocales.EN_GB,
    url: '/uk',
    iconFlag: 'gb-flag',
    currency: '£ GBP',
    synonymous: ['GB', 'Great Britain', 'England', 'UK', 'Wales', 'Scotland', 'Northern Ireland'],
    labels: {
      titleLabel: 'Select or type your store',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.LATAM,
    lang: WcsLocales.ES_AR,
    langId: '-102',
    label: 'Uruguay',
    akamaiCC: WcsAkamaiCookies.URUGUAY,
    url: '/latam',
    iconFlag: 'co-flag',
    synonymous: ['UY', 'Uruguay'],
    hidden: true,
  },
  {
    id: WcsStoreId.USA,
    langId: '-1',
    label: 'USA',
    lang: WcsLocales.EN_US,
    url: '/usa',
    currency: '$ USD',
    iconFlag: 'usa-flag',
    synonymous: ['US', 'USA', 'United States of America'],
    labels: {
      titleLabel: 'Select or type your store',
      currencyLabel: 'Currency',
      paymentsLabel: 'Available payment methods',
      benefitsLabel: 'Benefits',
      shippingLabel: 'You’re shipping to',
      submitLabel: 'Select',
      typeLabel: 'Choose different store',
    },
  },
  {
    id: WcsStoreId.CHINA,
    langId: '-7',
    label: '中国大陆',
    lang: WcsLocales.ZH_CN,
    url: '.cn/zh',
    iconFlag: 'xx-flag',
    currency: '元 CNY',
    synonymous: [
      'CN',
      'Zhongguo',
      'Zhonghua',
      'Peoples Republic',
      '中国 (简体中文)',
      'China',
      'Cina',
      'Mainland China',
    ],
    labels: {
      titleLabel: '选择或键入你的商店。',
      currencyLabel: '货币',
      paymentsLabel: '可用的付款方式',
      benefitsLabel: '优势',
      shippingLabel: '你指定寄送到',
      submitLabel: '选择',
      typeLabel: '选择其他商店',
    },
  },
  {
    id: WcsStoreId.JAPAN,
    langId: '-52',
    label: '日本',
    lang: WcsLocales.JA_JP,
    url: '/japan',
    currency: '円 JPY',
    iconFlag: 'jp-flag',
    synonymous: ['Japan', 'JP', 'Nippon Nihon 日本'],
    labels: {
      titleLabel: 'ストアを選択するか入力',
      currencyLabel: '通貨',
      paymentsLabel: '支払方法',
      benefitsLabel: 'メリット',
      shippingLabel: '配送先',
      submitLabel: '選択',
      typeLabel: '別のストアを選択',
    },
  },
  {
    id: WcsStoreId.HONG_KONG,
    langId: '-49',
    label: '香港特别行政区',
    lang: WcsLocales.ZH_HK,
    url: '/hongkong/zh',
    iconFlag: 'xx-flag',
    currency: 'HK$',
    synonymous: ['HK', '中国香港 '],
    labels: {
      titleLabel: '選擇或鍵入你的商店。',
      currencyLabel: '货币',
      paymentsLabel: '可用的付款方式',
      benefitsLabel: '优势',
      shippingLabel: '你指定寄送到',
      submitLabel: '選擇',
      typeLabel: '選擇其他商店',
    },
  },
]
